<template>
  <div class="app-container">
    <el-card class="register-card">
      <h2 class="title">注册页面</h2>
      <el-form :model="form" ref="form" class="register-form" @submit.native.prevent="handleSubmit">
        <el-form-item label="手机号" :rules="[{ required: true, message: '请输入手机号', trigger: 'blur' }]">
          <el-input v-model="form.phone" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item label="密码" :rules="[{ required: true, message: '请输入密码', trigger: 'blur' }]">
          <el-input type="password" v-model="form.password" placeholder="请输入密码"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" :rules="[{ required: true, message: '请确认密码', trigger: 'blur' }, { validator: validatePassword, trigger: 'blur' }]">
          <el-input type="password" v-model="form.confirmPassword" placeholder="请确认密码"></el-input>
        </el-form-item>
        <el-form-item label="验证码" :rules="[{ required: true, message: '请输入验证码', trigger: 'blur' }]">
          <div class="captcha-group">
            <el-input v-model="form.captcha" placeholder="请输入验证码" class="captcha-input"></el-input>
            <el-button type="primary" @click="sendCaptcha" :disabled="isCounting" class="captcha-button">{{ countdownText }}</el-button>
          </div>
          <span class="captcha-hint">验证码将发送至您的手机号</span> <!-- 提示文字 -->
        </el-form-item>
        <el-form-item class="button-container">
          <el-button type="success" @click="handleSubmit" class="submit-button">注册</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        phone: '',
        password: '',
        confirmPassword: '',
        captcha: '',
        info:this.$route.query.info.replace(' ', "+"),
      },

      countdown: 60,
      isCounting: false,
    };
  },
  computed: {
    countdownText() {
      return this.isCounting ? `${this.countdown}s` : '获取验证码';
    },
  },
  methods: {
    sendCaptcha() {
      if (this.isCounting) return;
      // 这里可以添加发送验证码的逻辑，例如调用 API
      this.sendMsg();

    },
    startCountdown() {
      this.isCounting = true;
      this.countdown = 60;
      const interval = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          clearInterval(interval);
          this.isCounting = false;
        }
      }, 1000);
    },
    validatePassword(rule, value, callback) {
      if (value !== this.form.password) {
        callback(new Error('密码不匹配'));
      } else {
        callback();
      }
    },
    isValidPhone() {
      // 手机号正则表达式（中国大陆手机号）
      const phoneRegex = /^1[3-9]\d{9}$/;

      return phoneRegex.test(this.form.phone);
    },
    sendMsg(){
      if(!this.isValidPhone()){
        this.msg('请输入正确的手机号码','error');
        return false
      }
      const form = {'phone':this.form.phone}
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	data:form,
      	url:'https://tossp.yoooooo.com/index.php/index/data/sendMsgs'
      })
      .then(res=>{
        if(res.data.code == 200){
          this.startCountdown();
        }
        if(res.data.code == 202){
          this.msg(res.data.data,'error');
        }

      })
      .catch(err=>{

      });
    },
    handleSubmit() {
      if(!this.isValidPhone()){
        this.msg('请输入正确的手机号码','error');
        return false
      }
      if(this.form.password != this.form.confirmPassword){
        this.msg('密码不一致','error');
        return false
      }
      if(!this.form.captcha){
        this.msg('请填写验证码','error');
        return false
      }
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	data:this.form,
      	url:'https://tossp.yoooooo.com/index.php/index/data/register'
      })
      .then(res=>{
        if(res.data.code == 200){
          this.msg(res.data.data,'success');

          this.$router.push({ path: '/Login?info='+this.form.info })
        }
        if(res.data.code == 202){
          this.msg(res.data.data,'error');
        }
         // console.log(res.data.data)
      })
      .catch(err=>{

      });
    },
    msg(msg,type){
    	this.$message({
    	  message: msg,
    	  type: type
    	});
    },
  },
};
</script>

<style scoped>
.app-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh; /* 使注册区域在页面垂直居中 */
  background-color: #f0f4f8; /* 背景色 */
}

.register-card {
  width: 400px; /* 注册卡片宽度 */
  padding: 30px; /* 内边距 */
  border-radius: 10px; /* 圆角 */
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1); /* 阴影效果 */
}

.title {
  text-align: center; /* 标题居中 */
  margin-bottom: 20px; /* 标题下边距 */
}

.captcha-group {
  display: flex;
  align-items: center;
}

.captcha-input {
  flex: 1; /* 输入框占满剩余空间 */
}

.captcha-button {
  width: 100px; /* 设置按钮宽度 */
  margin-left: 10px; /* 输入框与按钮之间的间距 */
}

.captcha-hint {
  display: block; /* 提示文字单独一行 */
  margin-top: 5px; /* 提示文字与输入框的间距 */
  color: #999; /* 提示文字颜色 */
}

.button-container {
  text-align: center; /* 注册按钮居中 */
}

.submit-button {
  width: 100%; /* 注册按钮宽度 */
}
</style>



// WEBPACK FOOTER //
// src/components/main/register.vue